<div *ngFor="let alert of alerts" class="{{alert.message?.cssClasses}} alert-area" [attr.type]="field.key"
    [hidden]="field.key!== alert.alertType">
    <span [innerHTML]="alert.message.qSubDescription"></span>
</div>